import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/auth.service";
import { DataServiceService } from "src/app/data-service.service";
import { LoginInfo } from "src/app/model/login";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginInfo: LoginInfo = {
    username: "",
    password: "",
  };
  isTCAccepted: boolean = false;
  showLoginPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  termsAndConditionsPdfUrl: string;

  // Reset password UI state
  showResetPassword = false;
  resetEmail = "";
  resetCode = "";
  newPassword = "";
  confirmPassword = "";
  isSendingCode = false;
  isResetting = false;
  codeSent = false;
  resetMessage = "";
  resetError = "";

  constructor(
    private router: Router,
    private authService: AuthService,
    private dataService: DataServiceService
  ) {
    this.termsAndConditionsPdfUrl = "/assets/pdf/iKYC_terms_and_conditions.pdf";
  }

  ngOnInit() {}

  onSubmit() {
    this.loginInfo.username = (
      document.getElementById("userName") as HTMLInputElement
    ).value;
    this.loginInfo.password = (
      document.getElementById("userPassword") as HTMLInputElement
    ).value;

    if (!this.isTCAccepted) {
      alert("Kindly accept the terms and conditions");
    } else {
      this.authService
        .authenticate(this.loginInfo)
        .then(
          (isLoginSuccessful) => {
            if (isLoginSuccessful) {
              localStorage.setItem("token", isLoginSuccessful);
              this.authService.setCurrentUser();
              this.dataService.updateLastLogin(
                this.authService.getCurrentUser().userId
              );
              this.authService.isUserAdmin()
                ? this.router.navigate(["admin-dashboard"])
                : this.router.navigate(["home"]);
            } else alert("Invalid Credentials");
          },
          (err) => alert("Invalid Credentials")
        )
        .catch((err) => alert("Invalid Credentials"));
    }
  }

  toggleTC() {
    this.isTCAccepted = !this.isTCAccepted;
  }

  toggleLoginPasswordVisibility() {
    this.showLoginPassword = !this.showLoginPassword;
  }

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  openResetPassword() {
    this.showResetPassword = true;
    this.resetMessage = "";
    this.resetError = "";
    this.codeSent = false;
    this.resetCode = "";
    this.newPassword = "";
    this.confirmPassword = "";
    this.showNewPassword = false;
    this.showConfirmPassword = false;
  }

  backToLogin() {
    this.showResetPassword = false;
    this.resetMessage = "";
    this.resetError = "";
    this.showNewPassword = false;
    this.showConfirmPassword = false;
  }

  invalidResetPassword() {
    return !String(this.newPassword || "").match(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm
    );
  }

  invalidMatchPassword() {
    return this.newPassword !== this.confirmPassword;
  }

  canSubmitReset() {
    return (
      this.resetEmail.trim() &&
      this.resetCode.trim() &&
      this.newPassword &&
      !this.invalidResetPassword() &&
      !this.invalidMatchPassword() &&
      !this.isResetting
    );
  }

  sendResetCode() {
    this.resetMessage = "";
    this.resetError = "";
    const email = this.resetEmail.trim();
    if (!email) {
      this.resetError = "Please enter your email.";
      return;
    }

    this.isSendingCode = true;
    this.dataService
      .forgotPassword(email)
      .then((resp) => {
        this.codeSent = true;
        if (resp && resp.emailSent) {
          this.resetMessage =
            "A reset code has been sent to your email. It is valid for 15 minutes.";
        } else if (resp && resp.resetCode) {
          this.resetCode = resp.resetCode;
          this.resetMessage =
            resp.message ||
            "Email delivery failed. The reset code has been filled in below and is valid for 15 minutes.";
        } else {
          this.resetMessage =
            resp?.message ||
            "If the account exists, a password reset code has been generated.";
        }
        this.isSendingCode = false;
      })
      .catch((err) => {
        this.resetError =
          err?.error?.message || "Failed to request reset code. Please try again.";
        this.isSendingCode = false;
      });
  }

  submitResetPassword() {
    this.resetMessage = "";
    this.resetError = "";

    if (!this.canSubmitReset()) {
      if (this.invalidResetPassword()) {
        this.resetError =
          "Password must be at least 8 characters and include upper, lower and a number.";
      } else if (this.invalidMatchPassword()) {
        this.resetError = "Passwords do not match.";
      } else {
        this.resetError = "Please fill in all required fields.";
      }
      return;
    }

    this.isResetting = true;
    this.dataService
      .resetPassword({
        email: this.resetEmail.trim(),
        resetCode: this.resetCode.trim(),
        password: this.newPassword,
      })
      .then((resp) => {
        this.resetMessage =
          resp?.message || "Password has been reset successfully.";
        this.resetCode = "";
        this.newPassword = "";
        this.confirmPassword = "";
        this.codeSent = false;
        this.isResetting = false;
        setTimeout(() => {
          this.backToLogin();
        }, 1500);
      })
      .catch((err) => {
        this.resetError =
          err?.error?.message || "Failed to reset password. Please try again.";
        this.isResetting = false;
      });
  }
}
